export default "__VITE_ASSET__2J$NBbHO__"